import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
//import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';

i18n
  .use(XHR)
  //.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'pl',
    fallbackLng: 'pl',
    /* eslint-disable no-undef */
    debug: __DEV__,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/assets/locales/{{lng}}.json',
    },
    react: {
      wait: true,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default',
      useSuspense: false,
    },
    detection: {
      order: ['querystring', 'navigator'],
    }
  });

i18n.on('languageChanged', lng => moment.locale(lng));

export default i18n;
